import { emailSchema } from "./email.schema";
import { z } from "zod";

export const checkEmailSchema = z.object({
  email: emailSchema,
});
